import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, {useContext} from 'react';
import Avatar from 'shared/components/avatar';
import Notifications from 'shared/components/notifications';
import {useBoolean} from 'src/hooks/useBoolean';
import {UserType} from 'src/types/enums';
import AboutMeForm from 'src/views/transfer/about-me-form/about-me-form';
import Bio from 'src/views/transfer/Bio';
import {PlatformContext} from '../../../components/PlatformContext';
import {useMediaQuery} from '../../../hooks/useMediaQuery';

const propTypes = {
  student: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    followedCollegeIds: PropTypes.array,
    followedCollegesTransferTerms: PropTypes.any,
    communityCollegeInfo: PropTypes.shape({
      transferYear: PropTypes.number,
      transferSemester: PropTypes.string,
      intendedMajor: PropTypes.string,
    }).isRequired,
    gpa: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    hasCoursesOverTenYears: PropTypes.bool,
  }).isRequired,
  openCollegesNotOfferingTransferTermModal: PropTypes.func.isRequired,
};

const TransferAboutMe = (props) => {
  const editing = useBoolean(false);
  const mq = useMediaQuery();
  const platformContext = useContext(PlatformContext);

  const {student, openCollegesNotOfferingTransferTermModal} = props;

  return (
    <div
      className={classnames('about-me', {
        'ionic-about-me': mq.MS_AND_DOWN && platformContext.isIonic,
      })}
    >
      <div className="about-me-avatar">
        <Avatar image={student.image} editing={editing.value} userType={UserType.CC_STUDENT} />
      </div>
      <div className="about-me-wrapper">
        {editing.value ? (
          <AboutMeForm
            onCancel={editing.setFalse}
            name={`${student.firstName} ${student.lastName}`}
            followedCollegeIds={student.followedCollegeIds}
            openCollegesNotOfferingTransferTermModal={openCollegesNotOfferingTransferTermModal}
            followedCollegesTransferTerms={student.followedCollegesTransferTerms}
          />
        ) : (
          <Bio onClick={editing.setTrue} student={student} />
        )}
      </div>
      <Notifications />
    </div>
  );
};

TransferAboutMe.propTypes = propTypes;

export default TransferAboutMe;
